import Link from "next/link";
import type { ButtonProps } from "./button";
import { ArrowLongRightIcon } from "@heroicons/react/20/solid";

export interface TextLinkProps extends ButtonProps {
  text?: string;
  underline?: boolean;
  hoverVariant?: "text" | "background";
  hoverColor?: string;
  sideAlign?: boolean;
  sideAlignMobile?: boolean; // remove padding when align side (left/right) on small screens
  sideAlignClass?: string; // custom side align effect
  mail?: boolean;
  tel?: boolean;
  arrow?: boolean;
}

const TextLink = ({
  href,
  newTab,
  text,
  underline,
  mail,
  tel,
  className,
  children,
  ...props
}: TextLinkProps) => {
  const hoverVariant = props.hoverVariant ?? "text";
  const hoverColor =
    hoverVariant === "text"
      ? (props.hoverColor ?? "hover:text-orange")
      : hoverVariant === "background"
        ? `${props.hoverColor ? `hover:${props.hoverColor}/20` : "hover:bg-purpleblue/20"} hover:rounded-lg hover:py-2 ${props.sideAlignMobile ? "hover:xl:px-4" : props.sideAlign ? " " : (props.sideAlignClass ?? "hover:px-4")}`
        : "";
  return (
    <Link
      href={`${mail ? `mailto:${href}` : tel ? `tel:${href}` : href}`}
      aria-label={`${text}-link`}
      target={newTab ? "_blank" : ""}
      className={`${className ?? ""} ${hoverColor ?? "hover:text-orange"} ${underline ? "underline underline-offset-2" : ""}`}
    >
      {text}
      {children}
      {props.arrow ? (
        <ArrowLongRightIcon className="mb-0.5 ml-1 inline size-5 lg:size-6" />
      ) : undefined}
    </Link>
  );
};

export default TextLink;
